<template>
  <div>
    <v-data-table :loading="isLoading('get:equipamento')"  :items="tableData" :search="search" :headers="headers" :items-per-page="-1" height="900px" fixed-header>
      <template v-slot:top>
        <v-row class="mt-4" dense>
          <v-col cols="5">
            <v-text-field dense outlined v-model="search" label="Pesquisar" class="mx-0" append-icon="mdi-magnify" clearable />
          </v-col>
          <v-col class="text-end">
            <v-btn class="mr-4 elevation-0" text @click="atualizar"> <v-icon left>mdi-reload</v-icon> Atualizar  </v-btn>
            <v-btn color="success" class="elevation-0" @click="dialog.create = true"> <v-icon left> mdi-plus </v-icon>  Novo </v-btn>
          </v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="12" >
            <div class="d-flex justify-end align-center">
              <span class="mr-3 font-weight-bold title">Quantidade de Itens no Estoque:</span>
              <span class="headline font-weight-bold blue--text">
                {{ quantidadeTotal }}
              </span>
            </div>
            <div class="d-flex justify-end align-center">
              <span class="mr-3 font-weight-bold title">Valor Total do Estoque:</span>
              <span class="headline font-weight-bold blue--text">
                {{ valorEstoqueTotal | formatReal }}
              </span>
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.edit`]="{ item }">
        <v-btn icon @click="onSelectRow(item, 'update')">
          <v-icon color="green">
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.ativo`]="{ item }">
        <v-chip class="ma-2" :color="item.ativo ? 'blue' : 'grey'">
          <span class="white--text">{{ item.ativo ? 'Ativo' : 'Inativo' }}</span>
        </v-chip>
      </template>
      <template v-slot:[`item.custo`]="{ item }">
        {{ item.custo | formatReal }}
      </template>
       <template v-slot:[`item.valor`]="{ item }">
        {{ (item.qtd * item.valor_cobranca) | formatReal }}
      </template>
      <template v-slot:[`item.quantidade`]="{ item }">
        {{ item.qtd_media ? `${item.qtd_media} dias` : '' }}
      </template>
      <template v-slot:[`item.vida_util`]="{ item }">
        {{ item.vida_util ? `${item.vida_util} dias` : '' }}
      </template>
      <template v-slot:[`item.valor_cobranca`]="{ item }">
        <div v-if="item.valor_cobranca">
          {{ item.valor_cobranca | formatReal}}
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog.create" v-if="dialog.create" max-width="1200">
      <v-card>
        <v-card-title class="blod_color">
          Novo equipamento:
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog.create = false">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <EquipamentoNovo :currentItem="newItem" :loading="isLoading('post:equipamento')" :onSubmit="createEquipamento" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.update" v-if="dialog.update" max-width="1200">
      <v-card>
        <v-card-title class="blod_color">
          Editar equipamento: Id: {{ selectedRow.id}} - {{selectedRow.nome}}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog.update = false">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <EditarEquipamento :currentItem="selectedRow" :loading="isLoading('put:equipamento')" :onSubmit="updateEquipamento" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '../../../../http';
import UtilsFunc from '../../../../service/utilsFunc';
import EditarEquipamento from './EditarEquipamento.vue';
import EquipamentoNovo from './EquipamentoNovo.vue';
import './../../../../assets/css/styles.css';

export default {
  name: "Equipamento",
  data() {
    return UtilsFunc.withCRUDUtils({
      newItem: { ativo:1 },
      headers: [
        { text: "Editar", value: "edit", width: 50 },
        { text: "Id", value: "id", width: 90 },
        { text: "Nome do equipamento", value: "nome" },
        { text: "Tipo equipamento", value: "tipo_equipamento.nome" },
        { text: "Custo estimado", value: "custo" },
        { text: "Quantidade", value: "qtd" },
        { text: "Vida Útil Média", value: "quantidade" },
        { text: "Vida Útil Esperada", value: "vida_util" },
        { text: "Valor do Equipamento para Reposição", value: "valor_cobranca" },
        { text: "Valor do Estoque", value: "valor" },
        { text: "Status", value: "ativo" },
      ],
      defaultSort: {
        name: 'ativo',
        isDesc: true
      },
    });
  },
  methods: {
    async getEquipamento() {
      const LOADING_NAME = "get:equipamento";
      this.setLoading(LOADING_NAME);
      try {
        const { data } = await api.get("/equipamentos/nomeequipamentos/");
        data.sort((a, b) => {
          // Ordena por ativo (true vem antes de false)
          if (a.ativo !== b.ativo) {
            return a.ativo ? -1 : 1;
          }
          // Se ambos são ativos ou inativos, ordena por nome
          return a.nome.localeCompare(b.nome);
        });
        this.tableData = data;
      }
      catch (error) {
        this.$errorHandler(error);
        this.$toast.error(`Desculpe! Aconteceu algo errado. Deu erro ${error}`)
      }
      finally {
        this.setLoading(LOADING_NAME, true);
      }
    },
    async createEquipamento(fields) {
      const LOADING_NAME = "post:equipamento";
      this.setLoading(LOADING_NAME);
      try {
        // console.log(fields)
        await api.post("/equipamentos/nomeequipamentos_criar/", fields);
        await this.getEquipamento()
        this.dialog.create = false
        this.$toast.success('Equiopamento criado com sucesso!')
      }
      catch (error) {
        this.$errorHandler(error);
        this.$toast.error(`Desculpe! Aconteceu algo errado. Deu erro ${error}`)
      }
      finally {
        this.setLoading(LOADING_NAME, true);
      }
    },
    async updateEquipamento(fields) {
      const LOADING_NAME = "put:equipamento";
      this.setLoading(LOADING_NAME);
      try {
        await api.put(`/equipamentos/nomeequipamento/${fields.id}/`, fields);
        await this.getEquipamento()
        this.dialog.update = false
        this.$toast.success('Equipamento atualizado com sucesso!')
      }
      catch (error) {
        this.$errorHandler(error);
        this.$toast.error(`Desculpe! Aconteceu algo errado. Deu erro ${error}`)
      }
      finally {
        this.setLoading(LOADING_NAME, true);
      }
    },
    atualizar(){
      this.getEquipamento();
      this.search = '';
    },
  },
  computed: {
    valorEstoqueTotal() {
      return this.tableData
        .filter(item => item.ativo && item.valor_cobranca !== null) // Filtra itens ativos com valor de cobrança
        .reduce((total, item) => {
          return total + (item.valor_cobranca * item.qtd);
        }, 0);
    },
    quantidadeTotal() {
    return this.tableData
      .filter(item => item.ativo) // Filtra apenas os itens ativos
      .reduce((total, item) => {
        return total + item.qtd; // Soma a quantidade de cada item
      }, 0);
    }
  },
  mounted() {
    this.getEquipamento();
  },
  components: { EditarEquipamento, EquipamentoNovo }
}
</script>
